"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFieldValueGetter = void 0;
const get_field_value_1 = require("./helpers/get-field-value");
/**
 * Class to safely retrieve field value.
 */
class BaseFieldValueGetter {
    constructor() {
        this.getFieldValue = (field, record) => {
            const fieldValue = (0, get_field_value_1.getValueFromRecordBySlug)(record, field);
            if (fieldValue === undefined)
                return this.getEmptyValue();
            if (this.isOptimizedFieldValue(fieldValue))
                return this.getValueFromOptimized(fieldValue);
            if (!this.isValidFieldValue(fieldValue, field))
                return this.getEmptyValue();
            return fieldValue;
        };
        this.getNestedFieldValue = (parentField, nestedFieldSlug, record) => {
            const parentFieldValue = this.getFieldValue(parentField, record);
            return (0, get_field_value_1.getNestedValueFromParentValueBySlug)(parentFieldValue, nestedFieldSlug);
        };
        this.getEmptyValue = () => null;
        /** Check if field value is optimized.
         *
         * By default, it's not optimized.
         *
         * */
        this.isOptimizedFieldValue = (fieldValue) => false;
        this.getValueFromOptimized = (fieldValue) => this.getEmptyValue();
    }
}
exports.BaseFieldValueGetter = BaseFieldValueGetter;
